export const tooltipMessages = {
    xing: "Wenn Du uns das verrätst, können wir die Newsletter Inhalte besser auf Dich zuschneiden"
};
//# sourceMappingURL=tooltips.js.map